import React, { Component } from 'react';
import PlaceholderWinsIllustration from './../../assets/placeholders/weekly_wins_placeholder.svg';

class PlaceholderStories extends Component {
  render() {
    return (
      <div className="weekly-wins-placeholder noStories">
        <img style={{width:'145px'}} src={PlaceholderWinsIllustration}/>
        <div className="subheader mt20">
          There are no posts created yet. You can create your own post about Diversity and Inclusion using the button above. 
        </div>
      </div>
    );
  }
}

export default PlaceholderStories;
